import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IPipelineMast } from "../../models/PipelineMast";
import { Fetch, hrLenseBaseUrl } from "../../shared/Fetch";
import { IModel } from "./PipelineMast";
import { ILogin, IPermissionProps } from "../../models/Login";
import { EmptyFilter, Filter, IPipelineFilter } from "./Filter";
import { format } from "date-fns";
import { Publish } from "../requirement/Publish";
import { IModel2 } from "../requirement/sales/TableAll";
import { FormEci } from "./FormEci";
import { LifeCycle } from "./LifeCycle";
import { Dialog } from "primereact/dialog";
import { Accordion, AccordionTab } from "primereact/accordion";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { User } from "../jvConnect/User";
import { Client_Type } from "../../models/RequirementMast";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps,
    ShowCelebration: (type: string) => void
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], td: [], loading: false } as { tableData: Array<IPipelineMast>, td: Array<IPipelineMast>, loading: boolean });
    const [tabData, setTabData] = useState({
        'Accepted by Sales Manager': 0,
        'Confirmed': 0,
        'Rejected': 0,
        'Backout': 0,
        'ECI Backed out': 0,
        'ECI Canceled': 0,
        'ECI Scheduled': 0,
        'ECI Rescheduled': 0,
        'Feedback Awaited': 0,
        'No feedback': 0,
        'No Call from PV': 0,
        'Others': 0,
        'Rejected by End Client': 0,
        'Rejected by PV': 0,
        'Rejected by Sales Manager': 0,
        'Selected For Next Round': 0,
        'Submitted by Recruiter': 0,
        'Submitted to End Client': 0,
        'Verbal confirmation': 0
    });
    const [plFilter, setPLFilter] = useState<IPipelineFilter>(EmptyFilter);
    const dt = useRef<any>(null);
    // const [visible, setVisible] = useState(false);

    const [userModal, setUserModal] = useState({ open: false, data: null, type: null } as any);
    const [userModalData, setUserModalData] = useState({ data: null as { employeeId?: number, empCode?: string, phoneNumber?: string, whatsAppNumber?: string, personalEmail?: string } | null });

    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };
    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };
    const [scheduleEci, setScheduleEci] = useState({ req_ID: 0, submission_ID: 0, client: '', open: false });
    const hideScheduleEciDialog = () => {
        setScheduleEci({ req_ID: 0, submission_ID: 0, client: '', open: false });
    };
    const [confirmECI, setConfirmECI] = useState({ rowData: {}, open: false } as { rowData: IPipelineMast, open: boolean });
    const hideConfirmEciDialog = () => {
        setConfirmECI({ rowData: {}, open: false });
    };

    useEffect(() => {
        loadTableData();
    }, [plFilter, props.reload]);

    useEffect(() => {
        if (tableData.td.length > 0) {
            const _tabData = {
                'Accepted by Sales Manager': 0,
                'Confirmed': 0,
                'Rejected': 0,
                'Backout': 0,
                'ECI Backed out': 0,
                'ECI Canceled': 0,
                'ECI Scheduled': 0,
                'ECI Rescheduled': 0,
                'Feedback Awaited': 0,
                'No feedback': 0,
                'No Call from PV': 0,
                'Others': 0,
                'Rejected by End Client': 0,
                'Rejected by PV': 0,
                'Rejected by Sales Manager': 0,
                'Selected For Next Round': 0,
                'Submitted by Recruiter': 0,
                'Submitted to End Client': 0,
                'Verbal confirmation': 0
            }
            tableData.td.forEach(d => {
                switch (d.status_Name) {
                    case 'Accepted by Sales Manager':
                        _tabData["Accepted by Sales Manager"] += 1;
                        break;
                    case 'Confirmed':
                        _tabData["Confirmed"] += 1;
                        break;
                    case 'Rejected':
                        _tabData["Rejected"] += 1;
                        break;
                    case 'Backout':
                        _tabData["Backout"] += 1;
                        break;
                    case 'ECI Backed out':
                        _tabData["ECI Backed out"] += 1;
                        break;
                    case 'ECI Canceled':
                        _tabData["ECI Canceled"] += 1;
                        break;
                    case 'ECI Scheduled':
                        _tabData["ECI Scheduled"] += 1;
                        break;
                    case 'ECI Rescheduled':
                        _tabData["ECI Rescheduled"] += 1;
                        break;
                    case 'Feedback Awaited':
                        _tabData["Feedback Awaited"] += 1;
                        break;
                    case 'No Call from PV':
                        _tabData["No Call from PV"] += 1;
                        break;
                    case 'No feedback':
                        _tabData["No feedback"] += 1;
                        break;
                    case 'Others':
                        _tabData["Others"] += 1;
                        break;
                    case 'Rejected by End Client':
                        _tabData["Rejected by End Client"] += 1;
                        break;
                    case 'Rejected by PV':
                        _tabData["Rejected by PV"] += 1;
                        break;
                    case 'Rejected by Sales Manager':
                        _tabData["Rejected by Sales Manager"] += 1;
                        break;
                    case 'Selected For Next Round':
                        _tabData["Selected For Next Round"] += 1;
                        break;
                    case 'Submitted by Recruiter':
                        _tabData["Submitted by Recruiter"] += 1;
                        break;
                    case 'Submitted to End Client':
                        _tabData["Submitted to End Client"] += 1;
                        break;
                    case 'Verbal confirmation':
                        _tabData["Verbal confirmation"] += 1;
                        break;
                }
            });
            setTabData(_tabData);
        }
    }, [tableData.td]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, td: tableData.td, loading: true });
        const response = await Fetch("Pipeline_Mast", "GET", null, `filter=${JSON.stringify(plFilter)}`, props.toast);
        if (response) {
            const data: Array<IPipelineMast> = await response.json();
            setTableData({ tableData: data, td: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, td: tableData.td, loading: false });
    }

    const yesScheduleECI = () => {
        hideConfirmEciDialog();
        scheduleECI(confirmECI.rowData);
    }
    const dontScheduleECI = () => {
        hideConfirmEciDialog();
        openEdit(confirmECI.rowData);
    }
    const openEdit = (rowData: IPipelineMast) => {
        props.setModal({ open: true, singleData: rowData });
    };
    const scheduleECI = (rowData: IPipelineMast) => {
        if (rowData.req_ID && rowData.submission_ID) setScheduleEci({ req_ID: rowData.req_ID, submission_ID: rowData.submission_ID, client: rowData.req_EndClient ? rowData.req_EndClient : "", open: true });
    };
    const [tLifeCycle, setTLifeCycle] = useState({ submission_ID: 0, consultant_Name: '', open: false } as { submission_ID: number, consultant_Name: string | undefined, open: boolean });
    const hideTLifeCycle = () => {
        setTLifeCycle({ submission_ID: 0, consultant_Name: '', open: false });
    }

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const filterTableDataFromTab = (status_Name: string) => {
        const _tableData = tableData.td.filter(t => t.status_Name === status_Name);
        setTableData({ tableData: _tableData, td: tableData.td, loading: false });
    }

    const DateFormat = loginObj?.date_Format;

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Pipeline</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <div style={{ display: 'flex' }}>
                    <Button label={`SUB-${tableData.td.length}`} className="p-button-info px-2 py-2 mx-1" tooltip="Total Submissions" tooltipOptions={{ position: 'top' }} onClick={() => { setTableData({ tableData: tableData.td, td: tableData.td, loading: false }) }} />
                    <Button label={`SBR-${tabData["Submitted by Recruiter"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="Submitted by Recruiter" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Submitted by Recruiter")} />
                    <Button label={`NCPV-${tabData["No Call from PV"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="No Call from PV" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("No Call from PV")} />
                    <Button label={`ASM-${tabData["Accepted by Sales Manager"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="Accepted by Sales Manager" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Accepted by Sales Manager")} />
                    <Button label={`RSM-${tabData["Rejected by Sales Manager"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="Rejected by Sales Manager" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Rejected by Sales Manager")} />
                    <Button label={`RPV-${tabData["Rejected by PV"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="Rejected by PV" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Rejected by PV")} />
                    <Button label={`ECS-${tabData["Submitted to End Client"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="Submitted to End Client" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Submitted to End Client")} />
                    <Button label={`ECI-${tabData["ECI Scheduled"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="ECI Scheduled" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("ECI Scheduled")} />
                    <Button label={`SNXT-${tabData["Selected For Next Round"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="Selected For Next Round" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Selected For Next Round")} />
                    <Button label={`ECIRS-${tabData["ECI Rescheduled"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="ECI Rescheduled" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("ECI Rescheduled")} />
                    <Button label={`ECIC-${tabData["ECI Canceled"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="ECI Canceled" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("ECI Canceled")} />
                    <Button label={`ECIB-${tabData["ECI Backed out"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="ECI Backed out" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("ECI Backed out")} />
                    <Button label={`ECIR-${tabData["Rejected by End Client"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="Rejected by End Client" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Rejected by End Client")} />
                    <Button label={`FWD-${tabData["Feedback Awaited"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="Feedback Awaited" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Feedback Awaited")} />
                    <Button label={`NFD-${tabData["No feedback"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="No feedback" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("No feedback")} />
                    <Button label={`VCON-${tabData["Verbal confirmation"]}`} className="p-button-info px-2 py-2 mx-1" tooltip="Verbal confirmation" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Verbal confirmation")} />
                    <Button label={`CONF-${tabData.Confirmed}`} className="p-button-info px-2 py-2 mx-1" tooltip="Confirmed" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Confirmed")} />
                    <Button label={`REJ-${tabData.Rejected}`} className="p-button-info px-2 py-2 mx-1" tooltip="Rejected" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Rejected")} />
                    <Button label={`BACK-${tabData.Backout}`} className="p-button-info px-2 py-2 mx-1" tooltip="Backout" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Backout")} />
                    <Button label={`Oths-${tabData.Others}`} className="p-button-info px-2 py-2 mx-1" tooltip="Others" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Others")} />
                    {/* <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" /> */}
                </div>
            </span>
        </div>
    );

    const req_Job_Title = (rowData: IPipelineMast) => {
        return (<span onClick={() => setPublish({ singleData: { req_ID: rowData.req_ID }, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>);
    };
    const subDate = (rowData: IPipelineMast) => {
        let date;
        if (rowData.subDate) date = format(new Date(rowData.subDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const status_Name = (rowData: IPipelineMast) => {
        // return (<>{props.permissions.is_Update && (rowData.status_Name === "Accepted by Sales Manager" || rowData.status_Name === "Submitted by Recruiter")
        return (<>{props.permissions.is_Update && (rowData.sales_Person_ID === loginObj.id || rowData.isSalesHead === true || _roles.includes(1) || _roles.includes(26)) && (rowData.status_Name === "Accepted by Sales Manager")
            ? <span onClick={() => openEdit(rowData)}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.status_Name}
            </span>
            : <>{props.permissions.is_Update && (rowData.sales_Person_ID === loginObj.id || rowData.isSalesHead === true || _roles.includes(1) || _roles.includes(26)) && rowData.status_Name === "Submitted to End Client"
                ? <span onClick={() => setConfirmECI({ rowData: rowData, open: true })}
                    className="cursor-pointer text-cyan-700 underline">
                    {rowData.status_Name}
                </span>
                : <>{_roles.includes(1) && (rowData.status_Name === "Rejected by PV" || rowData.status_Name === "Rejected by End Client" || rowData.status_Name === "Submitted by Recruiter" || rowData.status_Name === "Rejected by Sales Manager" || rowData.status_Name === "Requirement Hold by PV" || rowData.status_Name === "No Additional room for ECS" || rowData.status_Name === "PV Not Responding")
                    ? <span onClick={() => openEdit(rowData)}
                        className="cursor-pointer text-cyan-700 underline">
                        {rowData.status_Name}
                    </span>
                    : <>{rowData.status_Name}</>
                }</>
            }</>
        }</>);
    };
    const bLifeCycle = (rowData: IPipelineMast) => {
        return (
            <Button onClick={() => { if (rowData.submission_ID) setTLifeCycle({ submission_ID: rowData.submission_ID, consultant_Name: rowData.consultant_Name, open: true }) }} icon="pi pi-history" className="p-button-rounded p-button-secondary p-button-text" aria-label="History" />
        );
    };

    const rowClass = (data: any) => {
        if (data.client_Type === Client_Type.Implementing_Partner) {
            return 'bg-pink-100 font-semibold';
        } else {
            return ''; // default
        }
    };

    const getEmployeeDetails = async (empCode: string) => {
        const response = await fetch(`${hrLenseBaseUrl}/Tds_Slab/getempbycode?empCode=${empCode}`, { method: "GET" });
        if (response) {
            const data: { employeeId?: number, empCode?: string, phoneNumber?: string, whatsAppNumber?: string, personalEmail?: string } = await response.json();
            setUserModalData({ data });
        }
    }

    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter plFilter={plFilter} setPLFilter={(plFilter: IPipelineFilter) => setPLFilter(plFilter)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                emptyMessage="No Pipeline found."
                header={header}
                loading={tableData.loading}
                rowClassName={rowClass}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req.ID" sortable />
                <Column field="consultant_Name" header="Consultant Name" sortable />
                <Column field="req_Job_Title" header="Job Title" sortable body={req_Job_Title} />
                {!(_roles.includes(3) || _roles.includes(4) || _roles.includes(21)) && <Column field="req_EndClient" header="End Client" sortable />}
                {!((_roles.includes(3) || _roles.includes(4) || _roles.includes(34) || _roles.includes(40))) && <Column field="vendor_Company_Name" header="Prime Vendor" sortable />}
                <Column field="subVendor" header="Sub Vendor" sortable />
                {/* <Column field="subDate" header="Sub Date" body={subDate} /> */}
                <Column field="subDate" style={{ minWidth: '100px' }} header="Sub Date" sortable body={(rowData: any) => <span>{safeFormatDate(rowData.subDate, "dd/MM/yyyy", DateFormat)}</span>} />
                {/* <Column field="sales_Person_Name" header="Sales Manager" sortable /> */}
                <Column field="sales_Person_Name" header="Sales Manager" sortable body={(r: IPipelineMast) => {
                    const showInfo = r?.recruiter_ID === loginObj.id || r?.sales_Person_ID === loginObj.id;
                    return <User req={{
                        reqId: r.req_ID!,
                        subId: r.submission_ID,
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.subDate ?? '',
                        userId: r.sales_Person_ID ?? 0,
                        userName: r.sales_Person_Name ?? '',
                    }} show={showInfo} />
                }} />
                <Column field="sales_Person_Company_Name" header="Sales Comp(Branch)" sortable />
                {/* <Column field="recruiter" header="Recruiter" sortable /> */}
                <Column field="recruiter" header="Recruiter" sortable body={(r: IPipelineMast) => {
                    const showInfo = r?.recruiter_ID === loginObj.id || r?.sales_Person_ID === loginObj.id;
                    return <User req={{
                        reqId: r.req_ID!,
                        subId: r.submission_ID,
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.subDate ?? '',
                        userId: r.recruiter_ID ?? 0,
                        userName: r.recruiter ?? '',
                    }} show={showInfo} />
                }} />
                <Column field="recruiter_Company_Name" header="Recruiter Comp(Branch)" sortable />
                <Column field="req_CategoryName" header="Skills Category" sortable />
                <Column field="reqPostedTime" sortable header="ReqPostedTime" />
                {/* <Column field="reqPostedTime" header="Req Posted Time" style={{ minWidth: '100px' }} sortable body={(rowData: any) => <span>{safeFormatDate(new Date(rowData?.reqPostedTime?.split(" ")[0].split("-")[2], rowData?.reqPostedTime?.split(" ")[0].split("-")[1], rowData?.reqPostedTime?.split(" ")[0].split("-")[0]).toDateString(), "dd/MM/yyyy", DateFormat)} {rowData?.reqPostedTime?.split(" ")[1]} {rowData?.reqPostedTime?.split(" ")[2]}</span>} /> */}
                <Column field="allocationTime" sortable header="AllocationTime" />
                {/* <Column field="allocationTime" header="AllocationTime" sortable body={(rowData: any) => <span>{safeFormatDate(new Date(rowData?.allocationTime?.split(" ")[0].split("-")[2], rowData?.allocationTime?.split(" ")[0].split("-")[1], rowData?.allocationTime?.split(" ")[0].split("-")[0]).toDateString(), "dd/MM/yyyy", DateFormat)} {rowData?.allocationTime?.split(" ")[1]} {rowData?.allocationTime?.split(" ")[2]}</span>} /> */}
                <Column field="submissionTime" sortable header="SubmissionTime" />
                {/* <Column field="submissionTime" sortable header="SubmissionTime" body={(rowData: any) => <span>{safeFormatDate(new Date(rowData?.submissionTime?.split(" ")[0].split("-")[2], rowData?.submissionTime?.split(" ")[0].split("-")[1], rowData?.submissionTime?.split(" ")[0].split("-")[0]).toDateString(), "dd/MM/yyyy", DateFormat)} {rowData?.submissionTime?.split(" ")[1]} {rowData?.submissionTime?.split(" ")[2]}</span>} /> */}
                <Column field="litency" header="Latency" />
                <Column field="client_Type" header="Client Type" hidden body={(rowData: any) => rowData.client_Type ? Client_Type[rowData.client_Type] : ""} />
                <Column field="status_Name" header="Status" sortable body={status_Name} />
                <Column field="rejection_Status" header="Rejection Status" style={{ display: 'none' }} exportable={true} />
                <Column field="comments" header="LifeCycle" body={bLifeCycle} />
            </DataTable>
            <Dialog visible={userModal.open} onHide={() => {
                setUserModal({ open: false, data: null, type: null });
                setUserModalData({ data: null });
            }} header={`${userModal?.type || "User"} Details`} modal style={{ width: "30vw" }} >
                {userModal.data && (
                    <div className="p-fluid">
                        <div className="border-round surface-card p-4 shadow-2">
                            <div className="flex align-items-center mb-4"> <i className="pi pi-user text-primary text-xl mr-3" /> <div>
                                <div className="text-900 font-semibold text-lg">
                                    {userModal?.data?.name}
                                </div>
                                <div className="text-600 text-sm"> {userModal?.type} </div>
                            </div>
                            </div>
                            <div className="grid">
                                <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-envelope text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">Professional Email</div>
                                        <div className="text-900 font-medium"> {userModal?.data?.email} </div>
                                    </div>
                                </div>
                                {userModalData?.data?.personalEmail && <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-envelope text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">Email/Hangout</div>
                                        <div className="text-900 font-medium"> {userModalData?.data?.personalEmail} </div>
                                    </div>
                                </div>}
                                {userModalData?.data?.phoneNumber && <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-phone text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">Phone</div>
                                        <div className="text-900 font-medium"> {userModalData?.data?.phoneNumber} </div>
                                    </div>
                                </div>}
                                {userModalData?.data?.whatsAppNumber && <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-phone text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">WhatsApp</div>
                                        <div className="text-900 font-medium"> {userModalData?.data?.whatsAppNumber} </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                )}
            </Dialog>
            <Dialog visible={confirmECI.open} header="Schedule ECI ?" modal className="p-fluid" onHide={hideConfirmEciDialog}>
                <div style={{ display: 'flex' }}>
                    <Button icon='pi pi-check' onClick={yesScheduleECI} label="YES" className="p-button-raised p-button-success m-2" />
                    <Button icon='pi pi-times' onClick={dontScheduleECI} label="NO" className="p-button-raised p-button-danger m-2" />
                </div>
            </Dialog>
            <FormEci req_ID={scheduleEci.req_ID} submission_ID={scheduleEci.submission_ID} client={scheduleEci.client} reload={props.reload} setReload={props.setReload} toast={props.toast} hideDialog={hideScheduleEciDialog} open={scheduleEci.open} ShowCelebration={props.ShowCelebration} />
            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setPLFilter={(plFilter: IPipelineFilter) => setPLFilter(plFilter)} /> */}
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            <LifeCycle submission_ID={tLifeCycle.submission_ID} consultant_Name={tLifeCycle.consultant_Name} open={tLifeCycle.open} hideDialog={hideTLifeCycle} toast={props.toast} />
        </>
    );
}
